import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/notifications.css';
import AdminLayout from './layout/AdminLayout';
import MerchantLayout from './layout/MerchantLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Merchants from './pages/Merchants';
import Transactions from './pages/Transactions';
import Payouts from './pages/Payouts';
import AuditLogs from './pages/AuditLogs';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './shared/providers/LanguageProvider';
import Products from './pages/Products';
import Offers from './pages/Offers';
import OfferCreate from './pages/OfferCreate';
import ProductDetails from './pages/ProductDetails';
import Wallets from './pages/Wallets';
import WalletDetails from './pages/WalletDetails';
import Packages from './pages/Packages';
import Settings from './pages/Settings';
import MerchantDashboard from './pages/merchant/MerchantDashboard';
import MerchantProducts from './pages/merchant/MerchantProducts';
import MerchantOffers from './pages/merchant/MerchantOffers';
import MerchantDevices from './pages/merchant/MerchantDevices';
import PaymentSessions from './pages/merchant/PaymentSessions';
import MerchantBranches from './pages/merchant/MerchantBranches';
import ProductSalesAnalytics from './pages/merchant/ProductSalesAnalytics';
import MerchantProfile from './pages/merchant/MerchantProfile';
import MerchantRegistration from './pages/MerchantRegistration';
import MerchantResetPassword from './pages/MerchantResetPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Support from './pages/Support';
import RoleBasedAccess from './components/RoleBasedAccess';
import LoadingScreen from './components/common/LoadingScreen';
import './index.css';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <LoadingScreen type="splash" message="Authenticating..." />;
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { login, isAuthenticated, isMerchant, isAdmin } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login onLogin={login} />} />
      
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <RoleBasedAccess>
              {/* Merchant Routes */}
              {isMerchant && (
                <MerchantLayout>
                                  <Routes>
                  <Route path="/" element={<MerchantDashboard />} />
                  <Route path="/branches" element={<MerchantBranches />} />
                  <Route path="/products" element={<MerchantProducts />} />
                  <Route path="/offers" element={<MerchantOffers />} />
                  <Route path="/devices" element={<MerchantDevices />} />
                  <Route path="/payment-sessions" element={<PaymentSessions />} />
                  <Route path="/sales" element={<ProductSalesAnalytics />} />
                  <Route path="/payments" element={<div className="p-6">Payments - Coming Soon</div>} />
                  <Route path="/profile" element={<MerchantProfile />} />
                  <Route path="/settings" element={<div className="p-6">Settings - Coming Soon</div>} />
                </Routes>
                </MerchantLayout>
              )}
              
              {/* Admin Routes */}
              {isAdmin && (
                <AdminLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/merchants" element={<Merchants />} />
                    <Route path="/wallets" element={<Wallets />} />
                    <Route path="/wallets/:id" element={<WalletDetails />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:id" element={<ProductDetails />} />
                    <Route path="/offers" element={<Offers />} />
                    <Route path="/offers/new" element={<OfferCreate />} />
                    <Route path="/packages" element={<Packages />} />
                    <Route path="/transactions" element={<Transactions />} />
                    <Route path="/payouts" element={<Payouts />} />
                    <Route path="/audit-logs" element={<AuditLogs />} />
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </AdminLayout>
              )}
            </RoleBasedAccess>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/merchant-registration" element={<MerchantRegistration />} />
            <Route path="/merchant/reset-password" element={<MerchantResetPassword />} />
            
            {/* Private Routes */}
            <Route path="/*" element={<AppRoutes />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
